// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3HY0S","tab":"Tabs_tab__1huzN","tabActive":"Tabs_tabActive__1v9md"};